import React, { memo } from "react";
import SettingCardSkeleton from "./SettingCardSkeleton";

const DriveSettingSkeleton = memo(() => {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 lg:gap-7.5 mb-[20px]">
      <div className="col-span-2 grid gap-5 lg:gap-7.5">
        <SettingCardSkeleton
          titleWidth={160}
          controls={["input", "input"]}
          showFooter
        />
        <SettingCardSkeleton titleWidth={190} controls={["buttons"]} />
      </div>
    </div>
  );
});

DriveSettingSkeleton.displayName = "DriveSettingSkeleton";

export default DriveSettingSkeleton;
